import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import './LimitTextAreaField.css'
import TextAreaField from '../../atoms/TextAreaField/TextAreaField'

const LimitTextAreaField = ({ limitLength, text, handleChange }) => {
  return (
    <label>
      <TextAreaField handleChange={handleChange} limitLength={limitLength} currentText={text} />
      <p styleName="restTextLength">
        残り
        {limitLength - text.length}
        文字
      </p>
    </label>
  )
}

LimitTextAreaField.propTypes = {
  limitLength: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  handleChange: PropTypes.func
}

LimitTextAreaField.defaultProps = {
  text: ''
}

export default compose(pure)(LimitTextAreaField)
